var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var OI_INVALID_GRANT_ERROR = 'invalid_grant';
export var OI_LOGIN_REQUIRED_ERROR = 'login_required';
export var OI_INVALID_SCOPE_ERROR = 'invalid_scope';
export var OI_UNAUTHORIZED_CLIENT_ERROR = 'unauthorized_client';
export var OI_UNAUTHORIZED_ERROR = 'unauthorized';
var LoginRequiredError = (function (_super) {
    __extends(LoginRequiredError, _super);
    function LoginRequiredError() {
        var _this = _super.call(this) || this;
        _this.error = OI_LOGIN_REQUIRED_ERROR;
        _this.name = 'LoginRequiredError';
        _this.message = 'Login Required';
        return _this;
    }
    return LoginRequiredError;
}(Error));
export { LoginRequiredError };
//# sourceMappingURL=errors.js.map